module.exports = __webpack_public_path__ + "static/img/banner.71c4d9f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/la_liga/banner.png
// module id = 5g48
// module chunks = 1